import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

/**
 * Hook to check if badge verification clock-in feature is enabled.
 *
 * @returns Whether badge verification clock-in feature is enabled
 */
export function useIsBadgeVerificationClockInEnabled(): boolean {
  return useCbhFlag(CbhFeatureFlag.ENABLE_BADGE_VERIFICATION_CLOCK_IN, {
    defaultValue: false,
  });
}
